(function () {
  'use strict';

  var root = document.getElementById('pv-centros');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';

  /*
   * LISTA EDITABLE DE CENTROS
   * Para modificar un centro, cambia aquí el nombre, ciudad, dirección,
   * teléfono, horario o consulta de Google Maps.
   */
  var centers = [
    {
      id: 'mall-premier-tgu',
      city: 'Tegucigalpa',
      name: 'Mall Premier – Tegucigalpa',
      address: "Barrio La Laguna, frente al rótulo de Tropigas, hacia el estacionamiento, atrás de McDonald's.",
      phone: '3180-8513',
      phoneHref: '+50431808513',
      whatsapp: '50499535077',
      weekday: 'Lunes a viernes: 8:00 a.m. – 6:00 p.m.',
      saturday: 'Sábado: 8:00 a.m. – 5:00 p.m.',
      mapsQuery: 'PRONAVID Mall Premier Tegucigalpa Honduras'
    },
    {
      id: 'santa-monica-tgu',
      city: 'Tegucigalpa',
      name: 'Santa Mónica TGU',
      address: 'Centro Comercial Santa Mónica, Miraflores, frente al INFOP.',
      phone: '3396-4847',
      phoneHref: '+50433964847',
      whatsapp: '50499535077',
      weekday: 'Lunes a viernes: 8:00 a.m. – 6:00 p.m.',
      saturday: 'Sábado: 8:00 a.m. – 4:00 p.m.',
      mapsQuery: 'Centro Comercial Santa Monica Miraflores Tegucigalpa Honduras'
    },
    {
      id: 'mall-premier-comayagua',
      city: 'Comayagua',
      name: 'Comayagua',
      address: 'Centro Comercial Mall Premier, segundo nivel, frente al estacionamiento y a Almacenes El Titán.',
      phone: '3302-5755',
      phoneHref: '+50433025755',
      whatsapp: '50499535077',
      weekday: 'Lunes a viernes: 8:00 a.m. – 6:00 p.m.',
      saturday: 'Sábado: 8:00 a.m. – 5:00 p.m.',
      mapsQuery: 'PRONAVID Mall Premier Comayagua Honduras'
    },
    {
      id: 'gran-central-sps',
      city: 'San Pedro Sula',
      name: 'Gran Central SPS',
      address: 'Gran Central Metropolitana, primer nivel, contiguo a PACASA.',
      phone: '9436-4218',
      phoneHref: '+50494364218',
      whatsapp: '50499535077',
      weekday: 'Lunes a viernes: 8:00 a.m. – 6:00 p.m.',
      saturday: 'Sábado: 8:00 a.m. – 5:00 p.m.',
      mapsQuery: 'Gran Central Metropolitana San Pedro Sula Honduras'
    },
    {
      id: 'plaza-wip-sps',
      city: 'San Pedro Sula',
      name: 'Plaza WIP',
      address: 'Plaza WIP, San Pedro Sula.',
      phone: '2276-8888',
      phoneHref: '+50422768888',
      whatsapp: '50499535077',
      weekday: 'Lunes a viernes: 8:00 a.m. – 5:00 p.m.',
      saturday: 'Sábado: 8:00 a.m. – 12:00 p.m.',
      mapsQuery: 'Plaza WIP San Pedro Sula Honduras'
    },
    {
      id: 'unimall-choluteca',
      city: 'Choluteca',
      name: 'Choluteca',
      address: 'Bulevar Chorotega, Unimall, primer nivel frente a La Curacao.',
      phone: '9987-0020',
      phoneHref: '+50499870020',
      whatsapp: '50499535077',
      weekday: 'Lunes a viernes: 8:00 a.m. – 6:00 p.m.',
      saturday: 'Sábado: 8:00 a.m. – 5:00 p.m.',
      mapsQuery: 'PRONAVID Unimall Choluteca Honduras'
    },
    {
      id: 'plaza-saavedra-santa-rosa',
      city: 'Santa Rosa de Copán',
      name: 'Santa Rosa de Copán',
      address: 'Plaza Saavedra, local N.º 14, frente al Hotel VIP Copán.',
      phone: '9376-6037',
      phoneHref: '+50493766037',
      whatsapp: '50499535077',
      weekday: 'Lunes a viernes: 8:00 a.m. – 5:00 p.m.',
      saturday: 'Sábado: 8:00 a.m. – 12:00 p.m.',
      mapsQuery: 'Plaza Saavedra Santa Rosa de Copan Honduras'
    },
    {
      id: 'el-progreso',
      city: 'El Progreso',
      name: 'El Progreso',
      address: 'Super Mercado la Antorcha #2 Frente a Power Chicken Progreso.',
      phone: '2276-8888',
      phoneHref: '+50422768888',
      whatsapp: '50499535077',
      weekday: 'Lunes a viernes: 8:00 a.m. – 6:00 p.m.',
      saturday: 'Sábado: 8:00 a.m. – 12:00 p.m.',
      mapsQuery: 'PRONAVID El Progreso Yoro Honduras'
    },
    {
      id: 'cucuyagua',
      city: 'Cucuyagua',
      name: 'Cucuyagua',
      address: 'Carretera Internacional, barrio El Calvario, Cucuyagua, Copán.',
      phone: '2276-8888',
      phoneHref: '+50422768888',
      whatsapp: '50499535077',
      weekday: 'Lunes a viernes: 8:00 a.m. – 5:00 p.m.',
      saturday: 'Sábado: 8:00 a.m. –12:00 p.m.',
      mapsQuery: 'PRONAVID Cucuyagua Copan Honduras'
    },
    {
      id: 'laesperanza',
      city: 'La Esperanza',
      name: 'La Esperanza',
      address: 'El Centro, C.C. Ribel, contiguo a Banco Atlántida, La Esperanza, Intibucá',
      phone: '2276-8888',
      phoneHref: '+50422768888',
      whatsapp: '50499535077',
      weekday: 'Lunes a viernes: 8:00 a.m. – 6:00 p.m.',
      saturday: 'Sábado: 8:00 a.m. –5:00 p.m.',
      mapsQuery: 'Pronavid • La Esperanza'
    },
    {
      id: 'nacaome',
      city: 'Nacaome',
      name: 'Nacaome',
      address: 'Zona comercial de Nacaome, Valle, Honduras.',
      phone: '2276-8888',
      phoneHref: '+50422768888',
      whatsapp: '50499535077',
      weekday: 'Lunes a viernes: 8:00 a.m. – 5:00 p.m.',
      saturday: 'Sábado: 8:00 a.m. – 12:00 p.m.',
      mapsQuery: 'PRONAVID Nacaome Valle Honduras'
    }
    ,
    {
      id: 'danli',
      city: 'Danli',
      name: 'Danli',
      address: 'Plaza Paseo Las Colinas, Local #4, Danlí, El Paraíso',
      phone: '2276-8888',
      phoneHref: '+50422768888',
      whatsapp: '50499535077',
      weekday: 'Lunes a viernes: 8:00 a.m. – 5:00 p.m.',
      saturday: 'Sábado: 8:00 a.m. – 12:00 p.m.',
      mapsQuery: 'Pronavid • Paseo Las Colinas - Danlí'
    }
    ,
    {
      id: 'santa Barbara',
      city: 'Santa Barbara',
      name: 'Santa Barbara',
      address: 'Zona comercial de Nacaome, Valle, Honduras.',
      phone: '2276-8888',
      phoneHref: '+50422768888',
      whatsapp: '50499535077',
      weekday: 'Lunes a viernes: 8:00 a.m. – 5:00 p.m.',
      saturday: 'Sábado: 8:00 a.m. – 12:00 p.m.',
      mapsQuery: 'Pronavid • Santa Bárbara'
    }   ,
    {
      id: 'siguatepeque',
      city: 'Siguatepeque',
      name: 'Siguatepeque',
      address: 'Frente a tiendas Rosy, Barrio El Centro, Plaza Colonial, 12111 Siguatepeque, Comayagua',
      phone: '2276-8888',
      phoneHref: '+50422768888',
      whatsapp: '50499535077',
      weekday: 'Lunes a viernes: 8:00 a.m. – 6:00 p.m.',
      saturday: 'Sábado: 8:00 a.m. – 12:00 p.m.',
      mapsQuery: 'Pronavid Siguatepeque'
    }
  ];

  var state = {
    filtered: centers.slice(),
    selectedId: centers[0].id
  };

  var list = document.getElementById('pv-centros-list');
  var count = document.getElementById('pv-centros-count');
  var search = document.getElementById('pv-centros-search');
  var city = document.getElementById('pv-centros-city');
  var map = document.getElementById('pv-centros-map');
  var detailCity = document.getElementById('pv-centros-detail-city');
  var detailName = document.getElementById('pv-centros-detail-name');
  var detailAddress = document.getElementById('pv-centros-detail-address');
  var detailPhone = document.getElementById('pv-centros-detail-phone');
  var detailHours = document.getElementById('pv-centros-detail-hours');
  var detailBook = document.getElementById('pv-centros-detail-book');
  var detailMap = document.getElementById('pv-centros-detail-map');
  var prev = document.getElementById('pv-centros-prev');
  var next = document.getElementById('pv-centros-next');

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  function mapsUrl(center) {
    return 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(center.mapsQuery);
  }

  function mapEmbedUrl(center) {
    return 'https://maps.google.com/maps?q=' + encodeURIComponent(center.mapsQuery) + '&z=15&output=embed';
  }

  function bookingUrl(center) {
    var message = 'Hola, deseo agendar una consulta en ' + center.name + '.';
    return 'https://wa.me/' + center.whatsapp + '?text=' + encodeURIComponent(message);
  }

  function getSelected() {
    return centers.find(function (center) {
      return center.id === state.selectedId;
    }) || state.filtered[0] || centers[0];
  }

  function selectCenter(id, scrollDetail) {
    state.selectedId = id;
    var center = getSelected();

    detailCity.textContent = center.city;
    detailName.textContent = center.name;
    detailAddress.textContent = center.address;
    detailPhone.textContent = center.phone;
    detailPhone.href = 'tel:' + center.phoneHref;
    detailHours.innerHTML = center.weekday + '<br>' + center.saturday;
    detailBook.href = bookingUrl(center);
    detailMap.href = mapsUrl(center);
    map.src = mapEmbedUrl(center);

    Array.prototype.forEach.call(list.querySelectorAll('[data-center-id]'), function (card) {
      var active = card.getAttribute('data-center-id') === center.id;
      card.classList.toggle('is-active', active);
      card.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    if (scrollDetail && window.innerWidth < 791) {
      root.querySelector('.pv-centros__explorer').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function renderCards() {
    if (!state.filtered.length) {
      list.innerHTML = '<p class="pv-centros__empty">No encontramos centros con esa búsqueda. Prueba con otra ciudad o zona.</p>';
      count.textContent = '0 centros';
      return;
    }

    list.innerHTML = state.filtered.map(function (center) {
      return [
        '<button class="pv-centros__card' + (center.id === state.selectedId ? ' is-active' : '') + '"',
        ' type="button" data-center-id="' + center.id + '"',
        ' aria-pressed="' + (center.id === state.selectedId ? 'true' : 'false') + '">',
        '<span class="pv-centros__icon" aria-hidden="true">⌖</span>',
        '<span>',
        '<span class="pv-centros__card-city">' + center.city + '</span>',
        '<span class="pv-centros__card-name">' + center.name + '</span>',
        '<span class="pv-centros__card-address">' + center.address + '</span>',
        '<span class="pv-centros__card-phone">☎ ' + center.phone + '</span>',
        '</span>',
        '</button>'
      ].join('');
    }).join('');

    count.textContent = state.filtered.length + (state.filtered.length === 1 ? ' centro' : ' centros');
  }

  function filterCenters() {
    var term = normalize(search.value);
    var selectedCity = normalize(city.value);

    state.filtered = centers.filter(function (center) {
      var searchable = normalize([center.name, center.city, center.address].join(' '));
      var matchesTerm = !term || searchable.indexOf(term) !== -1;
      var matchesCity = !selectedCity || normalize(center.city) === selectedCity;
      return matchesTerm && matchesCity;
    });

    if (state.filtered.length && !state.filtered.some(function (center) { return center.id === state.selectedId; })) {
      state.selectedId = state.filtered[0].id;
      selectCenter(state.selectedId, false);
    }

    renderCards();
  }

  function moveSelection(direction) {
    var source = state.filtered.length ? state.filtered : centers;
    var current = source.findIndex(function (center) { return center.id === state.selectedId; });
    if (current < 0) current = 0;
    var target = (current + direction + source.length) % source.length;
    selectCenter(source[target].id, false);
  }

  function populateCities() {
    var cities = centers.map(function (center) { return center.city; })
      .filter(function (value, index, array) { return array.indexOf(value) === index; })
      .sort(function (a, b) { return a.localeCompare(b, 'es'); });

    cities.forEach(function (name) {
      var option = document.createElement('option');
      option.value = name;
      option.textContent = name;
      city.appendChild(option);
    });
  }

  list.addEventListener('click', function (event) {
    var card = event.target.closest('[data-center-id]');
    if (!card) return;
    selectCenter(card.getAttribute('data-center-id'), true);
  });

  search.addEventListener('input', filterCenters);
  city.addEventListener('change', filterCenters);
  prev.addEventListener('click', function () { moveSelection(-1); });
  next.addEventListener('click', function () { moveSelection(1); });

  populateCities();
  renderCards();
  selectCenter(centers[0].id, false);
}());
